<template>
	<header>
		<div style="display: block;">
			<div class="cu-custom" style="height: 45px;">
				<div class="cu-bar fixed bg-gradual-black" style=" height: 45px; padding-top: 0px;">
					<div class="content text-gold" style="top: 0px;">
						<div>{{$t('renzhengzx')}}</div>
					</div>
					<div class="action" @click="changego">
						<text class="cuIcon-back" style="width: 50px;">
							<span></span>
						</text>
					</div>
				</div>
			</div>
		</div>
	</header>
	<div class="padding text-gold text-center bg-gradual-black" v-if="user.codeqq === 0">
		<div>
			<text class="text-xxl">
				<span>{{$t('dhjzg')}}</span>
			</text>
			<div class="cu-tag bg-grey text-xs margin-left-lg round" style="margin-bottom: 5px;">
				<text class="cuIcon-roundcheckfill">
					<span>
						<text>
							<span>{{$t('weirenzz')}}</span>
						</text>
					</span>
				</text>
			</div>
		</div>
	</div>
	<div class="padding " v-if="user.codeqq === 0">
		<div class="padding text-gold  bg-gradual-black" style="border-radius: 10px;height: 280px">
			<div class="margin-top padding">
				<text class="text-xl">
					<span>{{$t('renzyao')}}：</span>
				</text>
			</div>
			<div class="cu-list menu card-menu margin-top ">
				<div class="cu-item bg-gradual-black">
					<div class="content">
						<text class="cuIcon-communityfill text-gold">
							<span></span>
						</text>
						<text class="text-gold">
							<span>{{$t('reqawao')}}</span>
						</text>
					</div>
					<div class="action" @click="changeCode" v-if="shownput"><uni-button
							class="cu-btn round bg-gradual-black shadow"><uni-text
								class="cuIcon-commandfill"><span></span></uni-text>{{$t('hoafaa')}}</uni-button></div>
					<div class="cu-form-group bg-gradual-black-blue" v-if="showCodeInput"
						style="width: 50%; min-height: 40px; border-radius: 15px;"><uni-input class="border shadow "
							style="color: rgb(184, 167, 138);">
							<div class="uni-input-wrapper">
								<input maxlength="6" type="text" :placeholder="$t('yanzhengma')"
									style="font-size: 14px;" v-model="yanzhengma">
							</div>
						</uni-input></div>
				</div>
			</div>
			<div style="margin-left: 20px;">
				<text class="text-xs text-gold">
					<span>{{$t('sutfufk')}}</span>
				</text>
			</div>
			<button class="cuIcon-safe cu-btn bg-gradual-black lg round " style="width: 70%;margin-top:5%"
				@click="submitVerificationCode">{{$t('djlfjj')}}</button>
		</div>
	</div>
	<div class="padding text-gold text-center bg-gradual-black" v-if="user.codeqq === 1">
		<div>
			<text class="text-xxl">
				<span>{{$t('dhjzg')}}</span>
			</text>
			<div class="cu-tag bg-gradual-green text-xs margin-left-lg round" style="margin-bottom: 5px;">
				<text class="cuIcon-roundcheckfill">
					<span>
						<text>
							<span>{{$t('yirenz')}}</span>
						</text>
					</span>
				</text>
			</div>
		</div>
	</div>
	<div class="padding " v-if="user.codeqq === 1">
		<div class="padding text-gold  bg-gradual-black" style="border-radius: 10px;">
			<div class="margin-top padding">
				<text class="text-xl">
					<span>{{$t('renzyao')}}：</span>
				</text>
			</div>
			<div class="cu-list menu card-menu margin-top ">
				<div class="cu-item bg-gradual-black">
					<div class="content">
						<text class="cuIcon-communityfill text-gold">
							<span></span>
						</text>
						<text class="text-gold">
							<span>{{$t('reqawao')}}</span>
						</text>
					</div>
					<div class="action"></div>
					<div class="action text-green text-xxl">
						<text class="cuIcon-roundcheckfill ">
							<span></span>
						</text>
					</div>
				</div>
			</div>
			<div style="margin-left: 20px;">
				<text class="text-xs text-gold">
					<span>{{$t('sutfufk')}}</span>
				</text>
			</div>
		</div>
	</div>
</template>

<script>
	import userApi from "@/api/user";
	export default {
		name: "Renz",
		components: {},
		data() {
			return {
				user: "",
				showCodeInput: false,
				shownput: true,
				yanzhengma: "",
			};
		},
		methods: {
			onRefresh() {
				this.$toast.loading({
						message: this.$t('jiazaizhong'),
						forbidClick: true,
						duration: 0,
					}),
					userApi.userInfo().then((data) => {
						// console.log(data, 11122);
						this.user = data.msg;

						this.isLoading = false;
						this.$toast.clear();
					});
			},
			changego() {
				this.$router.go(-1);
			},
			changeCode() {
				userApi.emailtest().then(() => {
					// console.log(data.data, 1111);
					this.shownput = false;
					this.showCodeInput = true;
				});
			},
			submitVerificationCode() {
				userApi.emailgo(this.yanzhengma).then(() => {
					// console.log(data.data, 1111);
					this.$router.push({
						path: "/personal",
					});
				});
			},
		},
		created() {
			this.onRefresh();
		},
	};
</script>

<style lang="less" scoped>
	/* 点击时的按压效果 */
	.cu-btn:active {
		transform: translateY(4px) scale(0.98);
		box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
	}

	/* 渐变背景动画 */
	.bg-gradual-black {
		background: linear-gradient(135deg, #434343 0%, #000000 100%);
		background-size: 200% 200%;
		transition: background-position 0.5s;
	}

	.bg-gradual-black:active {
		background-position: 100% 100%;
	}

	/* 阴影强化效果 */
	.shadow {
		box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
	}

	.shadow:active {
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
	}

	/* 图标点击反馈 */
	.cuIcon-commandfill {
		transition: transform 0.3s;
	}

	.cu-btn:active .cuIcon-commandfill {
		transform: scale(0.9);
	}

	.bg-gradual-black-blue {
		background-image: linear-gradient(45deg, #0d99e6, #191a1a);
		color: #fff;
	}

	input::placeholder {
		color: #999;
		/* 设置浅灰色确保可见 */
		opacity: 1;
		/* 避免透明度问题 */

	}

	.cddass {
		top: auto !important;
		font-weight: bolder;
		color: grey;
		overflow: hidden;
		text-overflow: clip;
		white-space: pre;
		word-break: keep-all;
		pointer-events: none;
		line-height: inherit;
	}

	.cuIcon-commandfill:before {
		content: "\e73e";
	}

	.cuIcon-roundclosefill:before {
		content: "\e658";
	}

	.bg-grey {
		background-color: #8799a3;
		color: #fff;
	}

	.cu-custom {
		display: block;
		position: relative;
		box-sizing: border-box;
	}

	.bg-gradual-black {
		background-image: linear-gradient(45deg, #191a1a, #8799a3);
		color: #b8a78a;
	}

	.cu-bar .content {
		position: absolute;
		text-align: center;
		width: calc(100% - 194px);
		left: 0;
		right: 0;
		bottom: 0;
		top: 0;
		margin: auto;
		height: 34px;
		font-size: 17px;
		line-height: 34px;
		cursor: none;
		pointer-events: none;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}


	.cu-bar {
		display: flex;
		position: relative;
		align-items: center;
		min-height: 57px;
	}

	.cu-bar.fixed,
	.nav.fixed {
		position: fixed;
		width: 100%;
		top: 0;
		z-index: 1024;
		box-shadow: 0 0.5px 3px rgba(0, 0, 0, .1);
	}

	.cu-custom .cu-bar {
		min-height: 0;
		box-shadow: 0px 0px 0px;
		z-index: 9999;
	}

	.cu-custom .cu-bar .content {
		width: calc(100% - 252px);
	}

	.cu-bar .action {
		display: flex;
		align-items: center;
		height: 100%;
		justify-content: center;
		max-width: 100%;
	}

	.cu-list.menu {
		display: block;
		overflow: hidden;
	}

	.cu-list.menu>.cu-item {
		position: relative;
		display: flex;
		padding: 0 17px;
		min-height: 57px;
		background-color: #fff;
		justify-content: space-between;
		align-items: center;
	}

	.cu-list>.cu-item {
		transition: all .6s ease-in-out 0s;
		-webkit-transform: translateX(0px);
		transform: translateX(0px);
	}

	.bg-gradual-black {
		background-image: linear-gradient(45deg, #191a1a, #8799a3);
		color: #b8a78a;
	}

	.cu-list.menu>.cu-item .content {
		font-size: 17px;
		line-height: 1.6em;
		flex: 1;
	}



	.text-gold,
	.line-gold,
	.lines-gold {
		color: #b8a78a;
	}

	.padding {
		padding: 17px;
	}

	.margin-top {
		margin-top: 17px;
	}

	.text-xl {
		font-size: 20px;
	}

	.text-xs {
		font-size: 11px;
	}

	.bg-gradual-green {
		background-image: linear-gradient(45deg, #39b54a, #8dc63f);
		color: #fff;
	}

	.margin-left-lg {
		margin-left: 22px;
	}

	.cu-tag {
		font-size: 13px;
		vertical-align: middle;
		position: relative;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		box-sizing: border-box;
		padding: 0px 9px;
		height: 27px;
		font-family: Helvetica Neue, Helvetica, sans-serif;
		white-space: nowrap;
	}

	.round {
		border-radius: 2866px;
	}

	[class*="cuIcon-"] {
		font-family: cuIcon;
		font-size: inherit;
		font-style: normal;
	}

	.cuIcon-roundcheckfill:before {
		content: "\e656";
	}

	.text-center {
		text-align: center;
	}

	.cu-list.card-menu {
		overflow: hidden;
		margin-right: 17px;
		margin-left: 17px;
		border-radius: 11px;
	}

	.cu-list.menu {
		display: block;
		overflow: hidden;
	}

	.cu-list.menu>.cu-item {
		position: relative;
		display: flex;
		padding: 0 17px;
		min-height: 57px;
		background-color: #fff;
		justify-content: space-between;
		align-items: center;
	}

	.cu-list>.cu-item {
		transition: all .6s ease-in-out 0s;
		-webkit-transform: translateX(0px);
		transform: translateX(0px);
	}

	.cu-list.menu>.cu-item .content {
		font-size: 17px;
		line-height: 1.6em;
		flex: 1;
	}

	.cu-list.menu>.cu-item .content>text[class*=cuIcon] {
		display: inline-block;
		margin-right: 5px;
		width: 1.6em;
		text-align: center;
	}

	body {
		background-color: #f1f1f1;
		font-size: 16px;
		color: #333;
		font-family: Helvetica Neue, Helvetica, sans-serif;
	}

	.cuIcon-communityfill:before {
		content: "\e740";
	}

	.text-xxl {
		font-size: 25px;
	}

	.cuIcon-roundcheckfill:before {
		content: "\e656";
	}
</style>